import { peopleByGroup,shuffle } from "utils/home-page-data";
import MoreButton from "./MoreButton";
import { motion,AnimatePresence } from 'framer-motion';
import useEmblaCarousel from 'embla-carousel-react'
import { useCallback, useEffect,useState } from "react";
import { useTranslation } from "react-i18next";
import defaultImg from "assets/images/default_img.png"
import { useUser } from "redux/modules/user/hooks";
import { useHistory } from "react-router-dom";
import { randomExtension } from "utils/utils";

const animation = {
  initial: {
    opacity: 0,
    translateY: 25
  },
  whileInView: {
    opacity: 1,
    translateY: 0
  },
  transition: {
    duration: 0.8
  }
};

export default function ExploreSection() {
  const {t} = useTranslation();
  const { http } = global.services; 

  const {
    refreshPeople,
    explorePeople,
    setExplorePeople
  } = useUser();

  const fetchNotifications = async () => {  
        try {
          const { data } = await http.get("users/profile-display");
          setExplorePeople(data)
        } catch (err) {
          console.log(err);
          setExplorePeople(null)
        }finally {  
      }
    }

  useEffect(()=>{
    if(refreshPeople){
      fetchNotifications();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[refreshPeople])

  return (
    <div className="pt-[7.5rem] pb-[3.75rem] px-6">
      <motion.h1 className="text-center font-medium text-3xl md:text-5xl mb-9" {...animation}>  {t('exploreMorePeople')}</motion.h1>
        <motion.div className="container m-auto flex flex-col gap-8" 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}>
            <AnimatePresence>
          {explorePeople ? Object.entries(explorePeople).map(([key, item]) => (
              <HorizontalScroller key={key} items={shuffle(item)} groupKey={key} />
          )):
            <>
              <Skeleton/>
              <Skeleton/>
            </>
          }
          
        </AnimatePresence>
        </motion.div> 
        <motion.div {...animation} className="flex items-center justify-center mt-9">
        <MoreButton>
          {t('exploreMorePeople')}
        </MoreButton>
      </motion.div>
    </div>
  );
}



function HorizontalScroller({ items,groupKey }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    dragFree: true,
    loop: false, // no looping
  })
  const history = useHistory();
  const extension = randomExtension();
  const scrollPrev = useCallback(() => emblaApi?.scrollPrev(), [emblaApi])
  const scrollNext = useCallback(() => emblaApi?.scrollNext(), [emblaApi])

  return (
    <motion.div
      data-role="people-group"
      className="w-full max-w-[86.25rem] mx-auto"
      key={groupKey}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="flex flex-row items-center justify-between mb-4">
        <div className="font-bold text-lg md:text-[1.75rem]">{groupKey}</div>
        <div className="flex flex-row items-center gap-4">
          <button
            onClick={scrollPrev}
            className="border-[1.5px] border-onbg rounded-full w-[2.625rem] h-[2.625rem] flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-primary hover:text-white hover:border-primary outline-none"
          >
            <svg
              width="8"
              height="12"
              viewBox="0 0 8 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mr-[1.5px]"
            >
              <path
                d="M6.06211 1.1001L2.15206 5.01015C1.60533 5.55688 1.60532 6.44331 2.15206 6.99005L6.06211 10.9001"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>

          <button
            onClick={scrollNext}
            className="border-[1.5px] border-onbg rounded-full w-[2.625rem] h-[2.625rem] flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-primary hover:text-white hover:border-primary outline-none"
          >
            <svg
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="ml-[1.5px]"
            >
              <path
                d="M1.1625 1.1001L5.07255 5.01015C5.61928 5.55688 5.61928 6.44331 5.07255 6.99005L1.1625 10.9001"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>
      </div>

      <div ref={emblaRef} className="overflow-hidden">
        <div className="flex gap-6 select-none">
          {items.map((person,index) => (
            <div
              key={index}
              className="flex flex-col gap-4 text-center flex-[0_0_auto] w-[13.125rem]"
            >
              <div className="w-full h-[13.125rem] rounded-md bg-neutral-200 overflow-hidden flex items-center justify-center cursor-pointer"
                onClick={()=>window.location.href = `${process.env.REACT_APP_PUBLIC_DOMAIN}/${person.username}-${extension}/profile/${person.id}`}
              >
                <img
                  src={person?.profile_url || defaultImg}
                  alt="People"
                  className={`object-cover ${person?.profile_url ? 'w-full h-full' : 'w-1/2 h-1/2'} `}
                  onError={(e)=> e.src = defaultImg}
                />
              </div>
              <div className="font-medium text-xl">{person.profile_name}</div>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  )
}

export const Skeleton = ()=>{
  return(
    <div class="mx-auto w-full max-w-3xl rounded-md p-4">
      <div class="flex animate-pulse space-x-4">
        <div class="size-10 rounded-full bg-gray-200"></div>
        <div class="flex-1 space-y-6 py-1">
          <div class="h-2 rounded bg-gray-200"></div>
          <div class="space-y-3">
            <div class="grid grid-cols-3 gap-4">
              <div class="col-span-2 h-2 rounded bg-gray-200"></div>
              <div class="col-span-1 h-2 rounded bg-gray-200"></div>
            </div>
            <div class="h-2 rounded bg-gray-200"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

